if(!__webpack_require__.federation){
	__webpack_require__.federation = {
		initOptions: {"name":"hhgDiscoverV1","remotes":[{"alias":"hhgComponentsV2","name":"hhgComponentsV2","entry":"https://preprod-hhg-components-v2.hellohealthgroup.com/_next/static/chunks/remoteEntry.js","shareScope":"default"},{"alias":"hhgDiscoverV2","name":"hhgDiscoverV2","entry":"https://preprod-hhg-discover-fe-v2.hellobacsi.com/_next/static/chunks/remoteEntry.js","shareScope":"default"}],"shareStrategy":"loaded-first"},
		chunkMatcher: function(chunkId) {return !/^((2|54)97|(373|403|900)9|(456|597|670)3|1540|1885|6621|8775)$/.test(chunkId)},
		rootOutputDir: "../../",
		initialConsumes: undefined,
		bundlerRuntimeOptions: {}
	};
}